import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ProductDetailsComponent } from './product-details.component';
import { AuthGuard } from 'shared/auth/auth.guard';
import { PermissionsResolver } from 'shared/permissions/permissions.resolver';
import { ScorecardsResolver } from 'shared/scorecard/scorecards.resolver';
import { PermissionsGuard } from 'shared/permissions/permissions.guard';


@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'product-details-v2/:id/:segment',
        component: ProductDetailsComponent,
        canActivate: [AuthGuard, PermissionsGuard],
        data: { permissions: ['admin', 'catalog-view', 'catalog-edit', 'fitments', 'repository'] },
        resolve: {
          permissions: PermissionsResolver,
          scorecards: ScorecardsResolver,
        },
      },
      {
        path: 'product-details-v2/:id',
        redirectTo: 'product-details/:id/overview',
        pathMatch: 'full',
        data: { permissions: ['admin', 'catalog-view', 'catalog-edit', 'fitments', 'repository'] },
        resolve: {
          permissions: PermissionsResolver,
          scorecards: ScorecardsResolver,
        },
      },
      {
        path: 'product-details-v2/:id/:segment/edit',
        component: ProductDetailsComponent,
        canActivate: [AuthGuard, PermissionsGuard],
        data: { permissions: ['admin', 'catalog-view', 'catalog-edit', 'repository'] },
        resolve: {
          permissions: PermissionsResolver,
          scorecards: ScorecardsResolver,
        },
      },
    ])
  ],
  exports: [RouterModule]
})
export class ProductDetailsRoutingModule {}
